export const getRadioConversationConfig = (value = process.env.REACT_APP_RADIO_CONVERSATION_GALAXY_ID) => {
  const id = String(value || '').trim();
  return { enabled: Boolean(id), galaxyId: /^[a-f\d]{24}$/i.test(id) ? id.toLowerCase() : '' };
};
